module.exports = __webpack_public_path__ + "img/mainEventEnd_logo_20250613.d43b2ee8.png";